import React from 'react';

import {
  isIOS,
  isAndroidChrome,
} from '../../../../../helpers/serverRenderingUtils';

const ToolsSvg = () => {
  if (isIOS() || isAndroidChrome())
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 191 325"
        aria-hidden="true"
      >
        <defs>
          <rect id="a" width="173" height="307" rx="4" />
          <path
            id="c"
            d="M0 74.4A18.4 18.4 0 0 1 18.4 56h.03a18.4 18.4 0 0 1 0 36.81h-.02A18.4 18.4 0 0 1 0 74.41z"
          />
          <path
            id="e"
            d="M0 18.4A18.4 18.4 0 0 1 18.4 0h.03a18.4 18.4 0 0 1 0 36.81h-.02A18.4 18.4 0 0 1 0 18.41z"
          />
          <circle id="h" cx="16" cy="16" r="16" />
          <filter
            id="g"
            width="203.1%"
            height="203.1%"
            x="-51.6%"
            y="-51.6%"
            filterUnits="objectBoundingBox"
          >
            <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
            <feGaussianBlur
              in="shadowOffsetOuter1"
              result="shadowBlurOuter1"
              stdDeviation="5.5"
            />
            <feColorMatrix
              in="shadowBlurOuter1"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.134709013 0"
            />
          </filter>
        </defs>
        <g fill="none" fillRule="evenodd">
          <rect width="168" height="297" x="19" y="24" fill="#8940FA" rx="4" />
          <g transform="translate(4 4)">
            <mask id="b" fill="#fff">
              <use xlinkHref="#a" />
            </mask>
            <use fill="#343B42" xlinkHref="#a" />
            <path
              fill="#5A5F64"
              fillOpacity=".5"
              d="M-81 161.28c14.05-7 14.09-.18 26.06 0 14.9.22 18 12.22 28.1 19.92 7.47 5.69 22.42-19.93 40.48-19.92 18.06 0 17.82 20.01 32.54 20.01 10.58 0 26.45-20.02 42.78-20.02 16.33 0 22.64 19.84 34.9 19.93 12.25.1 15.8-19.92 30.81-19.92 15.01 0 18.39 26.6 25.23 26.45 6.92-.15 15.04-43.07 19.38-45.49 12.27-6.82 12.72 23.82 12.72 23.82V341H-81V161.28z"
              mask="url(#b)"
            />
            <g fill="#FFF" fillRule="nonzero" mask="url(#b)">
              <path d="M39.58 26.17h3.75v1.09h-4.95v-1.12c0-.78.28-1.35.84-1.7.2-.12.41-.23.66-.33l1.35-.5c.3-.12.51-.26.65-.43.14-.18.2-.39.2-.64 0-.26-.08-.47-.27-.64-.18-.17-.44-.26-.78-.26-.33 0-.61.08-.83.24a.96.96 0 0 0-.38.72h-1.33c.02-.64.26-1.14.74-1.5a2.9 2.9 0 0 1 1.77-.5c.69 0 1.25.19 1.7.55.45.38.67.83.67 1.38 0 .54-.13.97-.4 1.3-.28.32-.7.6-1.28.82l-1.36.52c-.27.1-.46.21-.58.34a.66.66 0 0 0-.17.47v.2zm8.92-3.13c.3-.53.78-.8 1.41-.8.61 0 1.13.23 1.56.69.46.48.7 1.11.7 1.89 0 .78-.24 1.41-.7 1.9-.44.45-.96.68-1.56.68-.6 0-1.04-.18-1.31-.53v2.77h-1.2v-7.26h.98l.12.66zm1.2 3.29a1.2 1.2 0 0 0 .85-.38c.27-.28.4-.65.4-1.13 0-.47-.11-.84-.34-1.1-.24-.28-.52-.4-.85-.4-.34 0-.61.09-.82.28-.22.19-.33.46-.34.82v.87c0 .32.1.57.33.76.21.18.47.28.77.28zm7.31-3.37a2.71 2.71 0 0 1 .5 1.52c0 .23 0 .44-.03.63H54.3c.01.4.1.72.29.96.18.25.46.38.83.38.5 0 .79-.22.88-.65h1.2c-.07.5-.3.88-.67 1.16-.39.3-.86.44-1.4.44-.66 0-1.2-.23-1.64-.7a2.66 2.66 0 0 1-.68-1.88c0-.79.23-1.42.68-1.9.43-.45.98-.67 1.63-.67.68 0 1.21.23 1.59.7zm-1.58.23c-.34 0-.6.1-.79.33-.19.21-.3.5-.33.84h2.1c0-.53-.18-.89-.51-1.07a1 1 0 0 0-.47-.1zm5.45-.94c.33 0 .64.05.93.15.29.1.54.26.75.48.46.47.7 1.12.7 1.95 0 .82-.24 1.46-.7 1.93-.42.43-.98.64-1.68.64a2.3 2.3 0 0 1-1.7-.64 2.6 2.6 0 0 1-.7-1.93c0-.84.23-1.49.7-1.95.42-.42.99-.63 1.7-.63zm1.18 2.57c0-.52-.1-.9-.3-1.16-.2-.26-.49-.39-.85-.39s-.65.13-.88.39c-.23.26-.35.64-.35 1.16 0 .51.1.9.31 1.16.2.26.49.39.85.39.35 0 .65-.13.88-.4.23-.25.34-.64.34-1.15zm3.7-1.78c.32-.53.79-.8 1.42-.8.61 0 1.13.23 1.56.69.46.48.7 1.11.7 1.89 0 .78-.24 1.41-.7 1.9-.44.45-.96.68-1.56.68-.6 0-1.04-.18-1.31-.53v2.77h-1.2v-7.26h.99l.1.66zm1.21 3.29a1.2 1.2 0 0 0 .85-.38c.27-.28.4-.65.4-1.13 0-.47-.1-.84-.34-1.1-.24-.28-.52-.4-.85-.4-.34 0-.61.09-.82.28-.22.19-.33.46-.34.82v.87c0 .32.11.57.33.76.21.18.47.28.77.28zm3.88-5.96h1.2v6.89h-1.2v-6.9zm6.5 2.59c.18.21.3.46.39.74.08.28.12.54.12.78 0 .23 0 .44-.04.63h-3.17c0 .4.1.72.29.96.18.25.46.38.83.38.5 0 .79-.22.88-.65h1.2c-.08.5-.3.88-.67 1.16-.39.3-.86.44-1.41.44-.65 0-1.2-.23-1.63-.7a2.66 2.66 0 0 1-.68-1.88c0-.79.23-1.42.68-1.9.43-.45.97-.67 1.63-.67.68 0 1.21.23 1.59.7zm-1.57.23c-.34 0-.6.1-.79.33-.19.21-.3.5-.33.84h2.1c0-.53-.18-.89-.52-1.07a1 1 0 0 0-.46-.1zm7.7 1.22c.38 0 .84.06 1.35.19v-.49c0-.34-.07-.59-.2-.75-.15-.17-.37-.25-.69-.25-.31 0-.55.06-.72.19a.62.62 0 0 0-.25.52h-1.3c0-.55.19-.95.58-1.2.4-.25.95-.37 1.66-.37 1.01 0 1.67.35 1.96 1.05.1.24.15.53.15.85v3.11h-1.04l-.09-.65c-.32.53-.8.79-1.46.79-.63 0-1.12-.15-1.48-.46-.32-.3-.48-.67-.48-1.12 0-.45.18-.8.54-1.05.35-.24.84-.36 1.46-.36zm1.35.94a4.3 4.3 0 0 0-1.11-.16c-.65 0-.98.21-.98.64 0 .18.08.34.23.47.15.13.38.2.71.2.33 0 .6-.11.81-.33.21-.22.33-.5.34-.82zm4.13-2c.3-.71.74-1.06 1.34-1.06.11 0 .26.02.43.07l-.02 1.18a2.67 2.67 0 0 0-.56-.06c-.8 0-1.19.55-1.19 1.64v2.14h-1.2v-4.9h1.2v.98zm6.45-.4a2.71 2.71 0 0 1 .5 1.52c0 .24 0 .45-.04.64H92.7c.01.4.1.72.29.96.18.25.46.38.83.38.5 0 .79-.22.88-.65h1.2c-.08.5-.3.88-.67 1.16-.39.3-.86.44-1.41.44-.65 0-1.2-.23-1.63-.7a2.66 2.66 0 0 1-.68-1.88c0-.79.23-1.42.68-1.9.43-.45.98-.67 1.63-.67.68 0 1.21.23 1.59.7zm-1.58.24c-.34 0-.6.1-.79.33-.19.21-.3.5-.33.84h2.1c0-.53-.18-.89-.51-1.07a1 1 0 0 0-.47-.1zm7.27.15c.3-.7.74-1.05 1.34-1.05.11 0 .25.02.43.07l-.02 1.18a2.67 2.67 0 0 0-.56-.06c-.8 0-1.2.55-1.2 1.64v2.14H99.9v-4.9h1.2v.98zm6.45-.38a2.71 2.71 0 0 1 .5 1.52c0 .23-.01.44-.04.63h-3.18c.02.4.12.72.3.96.18.25.46.38.83.38.5 0 .78-.22.88-.65h1.2c-.08.5-.3.88-.67 1.16-.39.3-.86.44-1.41.44-.65 0-1.2-.23-1.63-.7a2.66 2.66 0 0 1-.68-1.88c0-.79.23-1.42.68-1.9.43-.45.97-.67 1.63-.67.68 0 1.21.23 1.59.7zm-1.58.23c-.34 0-.6.1-.8.33-.18.21-.3.5-.33.84h2.1c0-.53-.17-.89-.5-1.07a1 1 0 0 0-.47-.1zm5.38-.94c.31 0 .6.05.84.15a1.96 1.96 0 0 1 1.22 1.62l-1.2.03a1.1 1.1 0 0 0-.3-.53.7.7 0 0 0-.5-.2c-.2 0-.36.02-.5.08a.93.93 0 0 0-.35.26 1.8 1.8 0 0 0-.34 1.17c0 .5.1.87.32 1.12a1 1 0 0 0 .79.38c.3 0 .53-.08.67-.22s.2-.34.2-.59h1.2c0 .54-.17.98-.53 1.34-.36.36-.87.54-1.53.54-.64 0-1.19-.23-1.63-.7-.46-.5-.7-1.13-.7-1.88 0-.8.24-1.43.7-1.9a2.2 2.2 0 0 1 1.64-.67zm5.43 0c.33 0 .64.05.93.15.3.1.54.26.75.48.47.47.7 1.12.7 1.95 0 .82-.23 1.46-.7 1.93-.42.43-.98.64-1.68.64a2.3 2.3 0 0 1-1.7-.64 2.6 2.6 0 0 1-.7-1.93c0-.84.23-1.49.7-1.95.42-.42 1-.63 1.7-.63zm1.18 2.57c0-.52-.1-.9-.3-1.16-.2-.26-.48-.39-.84-.39-.37 0-.66.13-.89.39-.23.26-.34.64-.34 1.16 0 .51.1.9.3 1.16.21.26.5.39.85.39.36 0 .65-.13.88-.4.23-.25.34-.64.34-1.15zm3.81-1.48c.3-.7.74-1.05 1.34-1.05.11 0 .26.02.43.07l-.02 1.18a2.67 2.67 0 0 0-.55-.06c-.8 0-1.2.55-1.2 1.64v2.14h-1.2v-4.9h1.2v.98zm6.23 3.17c-.3.6-.77.89-1.4.89-.63 0-1.15-.24-1.58-.71a2.74 2.74 0 0 1-.66-1.9c0-.76.21-1.38.63-1.85.41-.46.93-.7 1.54-.7s1.08.25 1.39.74v-2.61h1.2v6.89h-.98l-.14-.75zm-1.25-3.2c-.34 0-.62.14-.84.4-.23.28-.34.64-.34 1.1 0 .45.11.82.34 1.1.23.28.52.42.87.42.3 0 .55-.12.78-.35.24-.23.36-.53.36-.88v-.63a1.22 1.22 0 0 0-.36-.86c-.2-.2-.47-.3-.8-.3zm4.36-.94h1.19v4.89h-1.2v-4.9zm-.15-1.57c0-.22.07-.38.2-.5.12-.13.3-.2.54-.2.23 0 .41.07.54.2.14.12.2.28.2.5 0 .21-.06.38-.2.5a.76.76 0 0 1-.54.2c-.23 0-.42-.07-.54-.2a.67.67 0 0 1-.2-.5zm4.54 2.42c.32-.65.84-.97 1.56-.97.6 0 1.06.2 1.37.59.3.4.46.92.46 1.57v2.85h-1.2v-2.85c0-.37-.08-.64-.26-.82a.97.97 0 0 0-.74-.28c-.31 0-.59.14-.81.42-.23.28-.35.7-.36 1.27v2.26h-1.2v-4.88h1.05l.13.84zm5.56 2.04c-.4-.33-.6-.75-.6-1.26 0-.53.2-.95.63-1.28.4-.32.87-.47 1.39-.47.52 0 .96.1 1.31.29.04-.38.2-.7.5-.93.28-.23.61-.35 1-.35l-.06 1.14c-.58 0-.88.19-.9.57.25.3.37.62.37.94 0 .33-.06.6-.17.81-.12.22-.27.4-.47.55-.4.32-.9.48-1.47.48-.34 0-.64-.05-.9-.15-.28.08-.41.24-.41.48 0 .3.26.46.77.46h1.65c1.12 0 1.68.38 1.68 1.16 0 .26-.07.52-.2.77s-.32.47-.57.67a3.3 3.3 0 0 1-2.09.64c-.8 0-1.46-.16-1.97-.5-.47-.3-.7-.7-.7-1.15 0-.3.08-.54.27-.71.19-.18.43-.3.73-.34-.4-.24-.6-.54-.6-.9 0-.23.08-.43.23-.58.15-.16.34-.27.58-.34zm.9 2.11c-.63.03-.94.26-.94.71 0 .23.13.41.4.55.26.14.58.2.94.2.37 0 .65-.02.86-.08.2-.06.38-.14.52-.24.3-.2.46-.45.46-.73a.38.38 0 0 0-.13-.3c-.09-.07-.2-.11-.37-.11h-1.73zm1.56-3.38c0-.27-.08-.5-.23-.66-.15-.18-.38-.26-.7-.26-.3 0-.54.08-.7.26a.92.92 0 0 0-.25.66c0 .27.09.5.25.67.16.17.4.26.7.26.32 0 .55-.09.7-.26.15-.18.23-.4.23-.67z" />
            </g>
            <g mask="url(#b)">
              <g transform="translate(27 130.82)">
                <mask id="d" fill="#fff">
                  <use xlinkHref="#c" />
                </mask>
                <use fill="#E0E0E0" xlinkHref="#c" />
                <path
                  fill="#8940FA"
                  d="M25 68a7 7 0 1 1-14 0 7 7 0 0 1 14 0M27.54 93c1.43 0 2.56-1.08 2.45-2.34C29.42 83.86 26.2 77 18 77c-7.78 0-11.33 6.84-11.98 13.64C5.89 91.91 7 93 8.46 93h19.08z"
                  mask="url(#d)"
                />
                <g transform="translate(45.13 .86)">
                  <rect
                    width="32.23"
                    height="4.6"
                    y="11.5"
                    fill="#495058"
                    rx="2.3"
                  />
                  <rect width="67.23" height="4.6" fill="#495058" rx="2.3" />
                  <rect
                    width="32.23"
                    height="4.6"
                    y="77.3"
                    fill="#5A636C"
                    rx="2.3"
                  />
                  <rect
                    width="53.87"
                    height="4.6"
                    y="65.8"
                    fill="#5A636C"
                    rx="2.3"
                  />
                </g>
                <g transform="translate(81.55 11.76)">
                  <ellipse
                    cx="3.04"
                    cy="3.04"
                    fill="#D34CEF"
                    rx="3.04"
                    ry="3.04"
                  />
                  <path
                    stroke="#FFF"
                    strokeWidth="1.1"
                    d="M1.52 3.16l.92.89 2.12-2.03"
                  />
                </g>
              </g>
              <g transform="translate(27 121.1)">
                <mask id="f" fill="#fff">
                  <use xlinkHref="#e" />
                </mask>
                <use fill="#E0E0E0" xlinkHref="#e" />
                <path
                  fill="#8940FA"
                  d="M25 12a7 7 0 1 1-14 0 7 7 0 0 1 14 0M27.54 37c1.43 0 2.56-1.08 2.45-2.34C29.42 27.86 26.2 21 18 21c-7.78 0-11.33 6.84-11.98 13.64C5.89 35.91 7 37 8.46 37h19.08z"
                  mask="url(#f)"
                />
              </g>
              <g transform="translate(108.04 207.87)">
                <ellipse
                  cx="3.04"
                  cy="3.04"
                  fill="#D34CEF"
                  rx="3.04"
                  ry="3.04"
                />
                <path
                  stroke="#FFF"
                  strokeWidth="1.1"
                  d="M1.52 3.16l.92.89 2.12-2.03"
                />
              </g>
              <path
                fill="#FFF"
                fillRule="nonzero"
                d="M62.15 76c2.62 0 4.7.97 6.21 2.9 1.52 1.93 2.28 4.7 2.28 8.33s-.76 6.4-2.28 8.34a7.48 7.48 0 0 1-6.21 2.9c-2.63 0-4.7-.96-6.24-2.87-1.53-1.9-2.3-4.7-2.3-8.37 0-3.67.77-6.46 2.3-8.37A7.57 7.57 0 0 1 62.15 76zm5.66 11.25c0-2.83-.48-5-1.45-6.5a4.72 4.72 0 0 0-4.23-2.27c-1.86 0-3.27.76-4.23 2.27-.97 1.5-1.45 3.66-1.45 6.48 0 2.82.48 4.98 1.45 6.49a4.72 4.72 0 0 0 4.23 2.26c1.85 0 3.26-.75 4.23-2.26.97-1.5 1.45-3.66 1.45-6.47zm8.5 10.04a1.94 1.94 0 0 1-2-1.95c0-.54.18-1 .56-1.38.38-.38.86-.57 1.45-.57s1.08.2 1.47.57c.4.38.59.84.59 1.38 0 .54-.2 1-.59 1.38-.4.38-.89.57-1.49.57zm0-10.56a1.94 1.94 0 0 1-2-1.95c0-.54.18-1 .56-1.38.38-.38.86-.57 1.45-.57s1.08.2 1.47.57c.4.38.59.84.59 1.38 0 .54-.2 1-.59 1.38-.4.38-.89.57-1.49.57zM90.63 76c2.62 0 4.7.97 6.21 2.9 1.52 1.93 2.28 4.7 2.28 8.33s-.76 6.4-2.28 8.34a7.48 7.48 0 0 1-6.21 2.9c-2.63 0-4.7-.96-6.24-2.87-1.53-1.9-2.3-4.7-2.3-8.37 0-3.67.77-6.46 2.3-8.37A7.57 7.57 0 0 1 90.64 76zm5.66 11.25c0-2.83-.48-5-1.45-6.5a4.72 4.72 0 0 0-4.23-2.27c-1.85 0-3.26.76-4.23 2.27-.97 1.5-1.45 3.66-1.45 6.48 0 2.82.48 4.98 1.45 6.49a4.72 4.72 0 0 0 4.23 2.26c1.85 0 3.26-.75 4.23-2.26.97-1.5 1.45-3.66 1.45-6.47zm19.34-11.18v14.42h3.76v2.35h-3.76v5.25h-2.66v-5.25h-11.22v-2.1l11.36-14.67h2.52zM105 90.74h8.05V80.38L105 90.74z"
                opacity=".9"
              />
            </g>
            <circle cx="31.5" cy="22.5" r="2.5" fill="#FD6767" mask="url(#b)" />
            <g mask="url(#b)">
              <g transform="translate(71 265)">
                <use fill="#000" filter="url(#g)" xlinkHref="#h" />
                <use fill="#FD6767" xlinkHref="#h" />
              </g>
            </g>
            <g fill="#FFF" stroke="#FFF" strokeWidth="1.07" mask="url(#b)">
              <path d="M90.61 277.35a.7.7 0 0 0-.93 0l-3.21 2.85-3.21-2.85a.7.7 0 0 0-.93 0 .55.55 0 0 0 0 .82l3.21 2.86-3.21 2.85a.55.55 0 0 0 0 .83.7.7 0 0 0 .93 0l3.21-2.86 3.21 2.86a.7.7 0 0 0 .93 0 .55.55 0 0 0 0-.83l-3.21-2.85 3.21-2.86a.55.55 0 0 0 0-.82z" />
            </g>
          </g>
        </g>
      </svg>
    );
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 432 389">
      <defs>
        <filter
          id="a"
          width="122.5%"
          height="129.8%"
          x="-10.7%"
          y="-15.6%"
          filterUnits="objectBoundingBox"
        >
          <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="10"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter
          id="b"
          width="143.2%"
          height="113.6%"
          x="-21.6%"
          y="-6.8%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="1"
          />
          <feComposite
            in="shadowBlurOuter1"
            in2="SourceAlpha"
            operator="out"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <path
          id="c"
          d="M0 9.1A9.04 9.04 0 0 1 9 .06L28 0c4.97-.01 9 4 9 8.98v.03a9 9 0 0 1-9 9H9A9 9 0 0 1 0 9v.1z"
        />
        <filter
          id="e"
          width="143.2%"
          height="113.6%"
          x="-21.6%"
          y="-6.8%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="1"
          />
          <feComposite
            in="shadowBlurOuter1"
            in2="SourceAlpha"
            operator="out"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            result="shadowMatrixOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <path
          id="f"
          d="M0 9.06a9 9 0 0 1 8.96-9L28.04 0A8.92 8.92 0 0 1 37 8.94v.03a8.96 8.96 0 0 1-8.96 8.96H8.96C4 17.93 0 13.93 0 8.96v.1z"
        />
        <path id="i" d="M0 0h224.63a6 6 0 0 1 6 6v163a6 6 0 0 1-6 6H0V0z" />
        <filter
          id="h"
          width="102.2%"
          height="102.9%"
          x="-1.1%"
          y="-1.4%"
          filterUnits="objectBoundingBox"
        >
          <feGaussianBlur
            in="SourceAlpha"
            result="shadowBlurInner1"
            stdDeviation="2.5"
          />
          <feOffset in="shadowBlurInner1" result="shadowOffsetInner1" />
          <feComposite
            in="shadowOffsetInner1"
            in2="SourceAlpha"
            k2="-1"
            k3="1"
            operator="arithmetic"
            result="shadowInnerInner1"
          />
          <feColorMatrix
            in="shadowInnerInner1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13502038 0"
          />
        </filter>
        <path id="k" d="M6 0h16.75v34.2H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6z" />
        <filter
          id="j"
          width="126.4%"
          height="117.5%"
          x="-13.2%"
          y="-8.8%"
          filterUnits="objectBoundingBox"
        >
          <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="1"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.115772192 0"
          />
        </filter>
        <path id="m" d="M21.74 0h3.41v175h-3.41z" />
        <filter
          id="l"
          width="275.9%"
          height="103.4%"
          x="-87.9%"
          y="-1.7%"
          filterUnits="objectBoundingBox"
        >
          <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="1"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.115772192 0"
          />
        </filter>
        <rect id="n" width="175" height="325" rx="5" />
        <filter
          id="o"
          width="145.7%"
          height="124.6%"
          x="-25.7%"
          y="-12.3%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dx="-5" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="12.5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
        </filter>
        <rect id="q" width="175" height="73" x="1" y="242" rx="3" />
        <filter
          id="r"
          width="145.7%"
          height="209.6%"
          x="-25.7%"
          y="-54.8%"
          filterUnits="objectBoundingBox"
        >
          <feOffset dx="-5" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="12.5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd" transform="translate(26 22)">
        <g filter="url(#a)" transform="translate(0 10)">
          <g fill="#D34CEF">
            <path d="M110 69.89l5.98-8 2.8 5.07 3.67-19.6.86 5.07 2.8-20.43 2.85 20.02 1.4-6.99 3.86 23.72.67-1.51.58 1.37 1.01-1.37.39 1.78 1.74-1.65.58 1.24 2.75-22.9 2.36 23.04 2.07-11.8 2.13 11.25 1.06-1.37.29 1.78.86-1.1.78 1.1 2.12-8.16 6.51 9.44" />
            <path d="M110 68.85l5.98 8.01 2.8-5.08 3.67 19.61.86-5.07 2.8 20.43 2.85-20.02 1.4 6.99L134.22 70l.67 1.51.58-1.37 1.01 1.37.39-1.78 1.74 1.64.58-1.23 2.75 22.9L144.3 70l2.07 11.79 2.13-11.24 1.06 1.37.29-1.78.86 1.1.78-1.1 2.12 8.16 6.51-9.45M161.09 69.89l5.98-8 2.8 5.07 3.67-19.6.86 5.07L177.2 32l2.85 20.02 1.4-6.99 3.86 23.72.67-1.51.58 1.37 1-1.37.4 1.78 1.74-1.65.58 1.24 2.75-22.9 2.36 23.04 2.07-11.8 2.13 11.25 1.06-1.37.29 1.78.86-1.1.78 1.1 2.12-8.16 6.5 9.44" />
            <path d="M161.09 68.85l5.98 8.01 2.8-5.08 3.67 19.61.86-5.07 2.8 20.43 2.85-20.02 1.4 6.99L185.3 70l.67 1.51.58-1.37 1 1.37.4-1.78 1.74 1.64.58-1.23 2.75 22.9L195.39 70l2.07 11.79 2.13-11.24 1.06 1.37.29-1.78.86 1.1.78-1.1 2.12 8.16 6.5-9.45M211.27 69.89l5.98-8 2.8 5.07 3.67-19.6.86 5.07 2.8-20.43 2.85 20.02 1.4-6.99 3.86 23.72.67-1.51.58 1.37 1.01-1.37.4 1.78 1.73-1.65.58 1.24 2.75-22.9 2.36 23.04 2.07-11.8 2.13 11.25 1.06-1.37.3 1.78.85-1.1.78 1.1 2.12-8.16 6.51 9.44" />
            <path d="M211.27 68.85l5.98 8.01 2.8-5.08 3.67 19.61.86-5.07 2.8 20.43 2.85-20.02 1.4 6.99L235.5 70l.67 1.51.58-1.37 1.01 1.37.4-1.78 1.73 1.64.58-1.23 2.75 22.9L245.57 70l2.07 11.79 2.13-11.24 1.06 1.37.3-1.78.85 1.1.78-1.1 2.12 8.16 6.51-9.45" />
            <g>
              <path d="M261.46 70.45l5.98-8.03 2.8 5.1 3.67-19.67.86 5.1 2.8-20.5 2.85 20.07 1.4-7 3.86 23.78.67-1.5.58 1.36 1.01-1.37.4 1.78 1.73-1.65.58 1.24 2.75-22.96 2.36 23.1 2.07-11.83 2.13 11.28 1.06-1.38.3 1.8.85-1.1.78 1.1 2.12-8.19 6.51 9.47" />
              <path d="M261.46 70.34l5.98 8.01 2.8-5.08 3.67 19.61.86-5.07 2.8 20.43 2.85-20.02 1.4 7 3.86-23.73.67 1.51.58-1.37 1.01 1.37.4-1.78 1.73 1.64.58-1.23 2.75 22.9 2.36-23.04 2.07 11.8 2.13-11.25 1.06 1.37.3-1.78.85 1.1.78-1.1 2.12 8.16 6.51-9.45" />
            </g>
            <g>
              <path d="M313 70l5.98-8.03 2.8 5.09 3.67-19.66.86 5.09L329.1 32l2.85 20.07 1.4-7.01 3.86 23.79.67-1.51.58 1.37 1-1.37.4 1.78 1.74-1.65.58 1.24 2.75-22.96 2.36 23.1 2.07-11.83 2.13 11.28 1.06-1.38.29 1.79.86-1.1.78 1.1 2.12-8.18 6.5 9.47" />
              <path d="M313 69.89l5.98 8.01 2.8-5.08 3.67 19.61.86-5.07 2.8 20.43 2.85-20.02 1.4 6.99 3.86-23.72.67 1.51.58-1.37 1 1.37.4-1.78 1.74 1.64.58-1.23 2.75 22.9 2.36-23.04 2.07 11.79 2.13-11.24 1.06 1.37.29-1.78.86 1.1.78-1.1 2.12 8.16 6.5-9.45" />
            </g>
          </g>
          <g filter="url(#b)" transform="translate(92)">
            <path fill="#36DC5D" d="M17.57 20.72h1.86V118h-1.86V96.27z" />
            <path
              fill="#36DC5D"
              d="M14.66 13.51h7.68A1 1 0 0 1 23.2 15l-2.96 5.39a2 2 0 0 1-3.5 0l-2.96-5.39a1 1 0 0 1 .87-1.48z"
            />
            <path
              fill="#36DC5D"
              d="M14.67 13.96h7.66a1 1 0 0 1 .87 1.49l-3.83 6.86a1 1 0 0 1-1.74 0l-3.83-6.86a1 1 0 0 1 .87-1.49z"
            />
            <mask id="d" fill="#fff">
              <use xlinkHref="#c" />
            </mask>
            <use fill="#36DC5D" xlinkHref="#c" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M9.95 7.54c-.08-.46-.4-.68-.96-.68-.27 0-.48.05-.63.16-.16.1-.23.24-.23.4 0 .15.05.27.15.36.1.09.25.17.46.24l1.12.44c.39.15.68.34.9.57.2.22.3.5.3.85 0 .47-.17.84-.52 1.12a2.4 2.4 0 0 1-1.5.4c-.58 0-1.05-.13-1.4-.42-.4-.3-.62-.74-.64-1.3h.94c0 .42.22.69.66.8.13.04.3.06.53.06.22 0 .42-.06.6-.17.2-.1.29-.25.29-.44 0-.18-.05-.32-.16-.42-.1-.1-.26-.2-.5-.28l-1.02-.4a2.7 2.7 0 0 1-.92-.55c-.22-.2-.32-.5-.32-.86 0-.44.16-.78.5-1.03.34-.26.8-.39 1.39-.39.58 0 1.03.13 1.35.4.32.27.5.65.55 1.14h-.94zm1.68-1.44h4.16v.82h-1.6v4.38h-.95V6.92h-1.6V6.1zm5.8 0h1.18l1.7 5.2h-1l-.36-1.12h-1.93l-.36 1.12h-1l1.76-5.2zm-.17 3.36h1.46L18 7.23l-.74 2.23zM25.1 7.7c0 .36-.1.68-.31.94-.21.26-.51.44-.9.54l1.4 2.12h-1.24L22.9 9.27h-.72v2.03h-.95V6.1h1.92c.62 0 1.1.15 1.43.44.34.29.5.67.5 1.16zm-2.03.94c.35 0 .61-.08.79-.24a.8.8 0 0 0 .26-.62.84.84 0 0 0-.24-.62c-.16-.16-.4-.24-.72-.24h-.97v1.72h.88zM25.7 6.1h4.16v.82h-1.61v4.38h-.94V6.92h-1.61V6.1z"
              mask="url(#d)"
            />
          </g>
          <g filter="url(#e)" transform="translate(345)">
            <path fill="#E54751" d="M20.35 22.97H18.5V118h1.85z" />
            <path
              fill="#E54751"
              d="M15.62 14h7.61a1 1 0 0 1 .9 1.45L20.31 23a1 1 0 0 1-1.79 0l-3.8-7.54a1 1 0 0 1 .89-1.45z"
            />
            <mask id="g" fill="#fff">
              <use xlinkHref="#f" />
            </mask>
            <use fill="#E54751" xlinkHref="#f" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M12 6h3.34v.82h-2.4v1.36h2.25V9h-2.25v1.37h2.4v.82H12V6zm5.71 0L20 9.68V6h.94v5.2h-.96l-2.36-3.82v3.81h-.94V6h1.03zm6.4 0c.8 0 1.43.23 1.91.7.5.47.74 1.1.74 1.9 0 .79-.25 1.42-.74 1.89-.48.47-1.12.7-1.9.7h-1.7V6h1.7zm-.73 4.34h.73c.5 0 .89-.17 1.2-.5.28-.32.43-.73.43-1.24 0-.52-.15-.94-.44-1.26-.3-.32-.7-.48-1.19-.48h-.73v3.48z"
              mask="url(#g)"
            />
          </g>
          <g>
            <g transform="translate(0 114)">
              <path
                fill="#EBEBEB"
                d="M21.74 0h224.63a6 6 0 0 1 6 6v163a6 6 0 0 1-6 6H21.74V0z"
              />
              <use
                fill="#000"
                filter="url(#h)"
                transform="translate(21.74)"
                xlinkHref="#i"
              />
              <g transform="translate(37.95 131.62)">
                <rect width="202.63" height="36.76" fill="#FFF" rx="6" />
                <path
                  fill="#FFF"
                  d="M167.2 17.59v-1.84c0-.17.14-.3.3-.3h.27c.16 0 .3.12.3.3v1.84h1.83c.17 0 .31.13.31.3v.24a.3.3 0 0 1-.3.31h-1.85v1.84a.3.3 0 0 1-.29.3h-.28c-.16 0-.29-.12-.29-.3v-1.84h-1.84a.3.3 0 0 1-.3-.3v-.24a.3.3 0 0 1 .3-.31h1.84z"
                />
                <path
                  fill="#FD6767"
                  d="M19.16 27.57a9.2 9.2 0 1 1-.02-18.4 9.2 9.2 0 0 1 .02 18.4zm-1.84-11v3.63a1 1 0 0 0 1.52.85l2.94-1.82a1 1 0 0 0 0-1.7l-2.94-1.82a1 1 0 0 0-1.52.85z"
                />
                <g fill="#CCCDCF" transform="translate(184.21 18.38)">
                  <ellipse cx=".92" cy=".92" rx="1" ry="1" />
                  <ellipse cx="4.24" cy=".92" rx="1" ry="1" />
                  <ellipse cx="7.55" cy=".92" rx="1" ry="1" />
                </g>
              </g>
              <g transform="translate(201.9 145.22)">
                <ellipse
                  cx="5.53"
                  cy="5.51"
                  fill="#FD6767"
                  rx="5.53"
                  ry="5.51"
                />
                <path
                  fill="#FFF"
                  stroke="#FFF"
                  strokeWidth=".1"
                  d="M5.2 4.92V3.64c0-.18.15-.33.33-.33.17 0 .32.15.32.33v1.28h1.28c.18 0 .33.15.33.32 0 .18-.15.32-.33.32H5.85v1.28c0 .18-.15.33-.32.33a.33.33 0 0 1-.33-.33V5.56H3.92a.33.33 0 0 1-.33-.32c0-.18.15-.32.33-.32H5.2z"
                />
              </g>
              <g transform="translate(37.95 6.62)">
                <rect width="202.63" height="36.63" fill="#FFF" rx="6" />
                <g fill="#CCCDCF" transform="translate(184.21 17.58)">
                  <ellipse cx=".96" cy=".92" rx="1" ry="1" />
                  <ellipse cx="4.42" cy=".92" rx="1" ry="1" />
                  <ellipse cx="7.88" cy=".92" rx="1" ry="1" />
                </g>
                <g transform="translate(163.95 12.21)">
                  <ellipse
                    cx="5.53"
                    cy="5.5"
                    fill="#FD6767"
                    rx="5.53"
                    ry="5.5"
                  />
                  <path
                    fill="#FFF"
                    stroke="#FFF"
                    strokeWidth=".1"
                    d="M5.3 5.27V3.99c0-.18.15-.33.32-.33.18 0 .32.15.32.33v1.28h1.28c.18 0 .33.14.33.32 0 .17-.14.32-.33.32H5.94v1.27c0 .18-.15.33-.32.33a.32.32 0 0 1-.32-.33V5.91H4a.33.33 0 0 1-.33-.32c0-.18.15-.32.33-.32H5.3z"
                  />
                </g>
                <path
                  fill="#FD6767"
                  d="M19.16 27.48a9.18 9.18 0 0 1-9.21-9.16 9.18 9.18 0 0 1 9.2-9.16c5.1 0 9.22 4.1 9.22 9.16a9.18 9.18 0 0 1-9.21 9.16zM17.32 16.5v3.62a1 1 0 0 0 1.52.85l2.94-1.81a1 1 0 0 0 0-1.7l-2.94-1.81a1 1 0 0 0-1.52.85z"
                />
              </g>
              <rect
                width="202.63"
                height="36.76"
                x="37.95"
                y="47.43"
                fill="#FFF"
                rx="6"
              />
              <path
                fill="#FD6767"
                d="M56.74 74.63a9.2 9.2 0 1 1-.02-18.4 9.2 9.2 0 0 1 .02 18.4zm-1.85-11v3.63a1 1 0 0 0 1.53.85l2.94-1.82a1 1 0 0 0 0-1.7l-2.94-1.82a1 1 0 0 0-1.53.85z"
              />
              <g transform="translate(37.95 88.6)">
                <rect width="202.63" height="36.76" fill="#FFF" rx="6" />
                <path
                  fill="#FFF"
                  d="M167.2 17.59v-1.84c0-.17.14-.3.3-.3h.27c.16 0 .3.12.3.3v1.84h1.83c.17 0 .31.13.31.3v.24a.3.3 0 0 1-.3.31h-1.85v1.84a.3.3 0 0 1-.29.3h-.28c-.16 0-.29-.12-.29-.3v-1.84h-1.84a.3.3 0 0 1-.3-.3v-.24a.3.3 0 0 1 .3-.31h1.84z"
                />
                <path
                  fill="#FD6767"
                  d="M19.16 27.57a9.2 9.2 0 1 1-.02-18.4 9.2 9.2 0 0 1 .02 18.4zm-1.84-11v3.63a1 1 0 0 0 1.52.85l2.94-1.82a1 1 0 0 0 0-1.7l-2.94-1.82a1 1 0 0 0-1.52.85z"
                />
              </g>
              <g fill="#CCCDCF" transform="translate(222.07 64.77)">
                <ellipse cx=".93" cy=".89" rx="1" ry="1" />
                <ellipse cx="4.3" cy=".89" rx="1" ry="1" />
                <ellipse cx="7.66" cy=".89" rx="1" ry="1" />
              </g>
              <g transform="translate(201.53 59.56)">
                <ellipse cx="5.6" cy="5.33" fill="#FD6767" rx="5.6" ry="5.33" />
                <path
                  fill="#FFF"
                  stroke="#FFF"
                  strokeWidth=".1"
                  d="M5.37 5.1V3.88c0-.17.15-.32.33-.32.18 0 .32.15.32.32v1.24h1.33c.17 0 .3.14.3.31a.3.3 0 0 1-.3.31H6.02v1.24c0 .17-.15.32-.32.32a.32.32 0 0 1-.33-.32V5.73H4.04a.31.31 0 0 1-.3-.31.3.3 0 0 1 .3-.31h1.33z"
                />
              </g>
              <g fill="#CCCDCF" transform="translate(222.07 106.1)">
                <ellipse cx=".93" cy=".89" rx="1" ry="1" />
                <ellipse cx="4.3" cy=".89" rx="1" ry="1" />
                <ellipse cx="7.66" cy=".89" rx="1" ry="1" />
              </g>
              <g transform="translate(201.53 101.47)">
                <ellipse cx="5.6" cy="5.33" fill="#FD6767" rx="5.6" ry="5.33" />
                <path
                  fill="#FFF"
                  stroke="#FFF"
                  strokeWidth=".1"
                  d="M5.37 5.1V3.88c0-.17.15-.32.33-.32.18 0 .32.15.32.32v1.24h1.33c.17 0 .3.14.3.31a.3.3 0 0 1-.3.31H6.02v1.24c0 .17-.15.32-.32.32a.32.32 0 0 1-.33-.32V5.73H4.04a.31.31 0 0 1-.3-.31.3.3 0 0 1 .3-.31h1.33z"
                />
              </g>
              <g>
                <use fill="#000" filter="url(#j)" xlinkHref="#k" />
                <use fill="#FD6767" xlinkHref="#k" />
              </g>
              <path
                fill="#FFF"
                d="M14.7 14.41c.22 0 .4.17.4.39v2.33c0 1.8-1.4 3.28-3.18 3.47v2.15h1.34c.22 0 .4.18.4.4a.4.4 0 0 1-.4.38H9.8a.4.4 0 0 1-.4-.39.4.4 0 0 1 .4-.39h1.34V20.6a3.53 3.53 0 0 1-3.17-3.47V14.8a.4.4 0 0 1 .4-.39c.22 0 .4.17.4.39v2.33c0 1.5 1.24 2.72 2.77 2.72a2.75 2.75 0 0 0 2.77-2.72V14.8a.4.4 0 0 1 .4-.39zm-3.17 4.9a2.2 2.2 0 0 1-2.22-2.18v-4.66c0-1.2 1-2.18 2.22-2.18a2.2 2.2 0 0 1 2.22 2.18v4.66c0 1.2-1 2.17-2.22 2.17z"
              />
              <path
                fill="#2DCFB3"
                d="M6 40.07h16.75v34.2H6a6 6 0 0 1-6-6v-22.2a6 6 0 0 1 6-6z"
              />
              <path
                fill="#FFF"
                d="M11.3 56.3V54.88h-.85V56.3H9.03v.84H10.46V58.56h.85V57.13H12.7v-.84H11.3zm-5.42.42c0-2.5 2.2-4.51 4.92-4.51 2.73 0 4.93 2.02 4.93 4.5 0 1.08-.4 2.07-1.1 2.84.14.36.36.76.78 1.05.11.09.07.25-.05.27-.44.05-1.2.06-1.88-.36-.77.45-1.68.72-2.68.72-2.72 0-4.92-2.02-4.92-4.51z"
              />
              <path
                fill="#FFACE7"
                d="M6 120.22h16.75v34.2H6a6 6 0 0 1-6-6v-22.2a6 6 0 0 1 6-6z"
              />
              <path
                fill="#FFF"
                d="M14.87 137.97h-3.6a.68.68 0 0 1-.67-.68c0-.37.3-.68.68-.68h3.6l-2.4-2.33a.71.71 0 0 1-.01-1.03l-.07.07a.76.76 0 0 1 1.06 0l3.56 3.46h.01l.06.06-.07-.07a.7.7 0 0 1 .2.65.7.7 0 0 1-.2.38l.07-.07a.75.75 0 0 1-.07.07l-3.56 3.45a.77.77 0 0 1-1.06 0l.07.07a.7.7 0 0 1 0-1.02l2.4-2.33zm-7.06-.68c0-.37.3-.68.68-.68h.95a.68.68 0 1 1 0 1.36h-.95a.68.68 0 0 1-.68-.68zm-1.85 0c0-.37.3-.68.67-.68h.03a.68.68 0 0 1 0 1.36h-.03a.68.68 0 0 1-.67-.68z"
              />
              <g fill="#8940FA">
                <path d="M6 80.15h16.75v34.19H6a6 6 0 0 1-6-6v-22.2a6 6 0 0 1 6-6z" />
              </g>
              <path
                fill="#FFF"
                fillRule="nonzero"
                d="M16 94.49h-4.88l-1.64-1.1H6.75c-.58 0-1.06.46-1.06 1.03v6.75c0 .57.48 1.04 1.06 1.04H16c.59 0 1.07-.47 1.07-1.04v-5.7c0-.57-.48-.98-1.07-.98z"
              />
              <g>
                <use fill="#000" filter="url(#l)" xlinkHref="#m" />
                <use fill="#FD6767" xlinkHref="#m" />
              </g>
              <g fill="#EFEFEF" transform="translate(77.37 18.75)">
                <rect width="50.77" height="5.15" x=".07" rx="2.57" />
                <rect width="38.54" height="5.15" x=".07" y="7.37" rx="2.57" />
              </g>
              <g fill="#EFEFEF" transform="translate(77.37 59.2)">
                <rect width="50.84" height="5.15" rx="2.57" />
                <rect width="38.6" height="5.15" y="7.35" rx="2.57" />
              </g>
              <g fill="#EFEFEF" transform="translate(77.37 101.1)">
                <rect width="50.84" height="5.15" rx="2.57" />
                <rect width="38.6" height="5.15" y="7.35" rx="2.57" />
                <rect width="38.6" height="5.15" y="50.74" rx="2.57" />
              </g>
              <g fill="#EFEFEF" transform="translate(77.37 144.49)">
                <rect width="50.84" height="5.15" rx="2.57" />
              </g>
            </g>
          </g>
          <rect
            width="29.38"
            height="5"
            x="223.13"
            y="184"
            fill="#495058"
            rx="2.5"
          />
          <rect
            width="29.38"
            height="5"
            x="223.13"
            y="184"
            fill="#495058"
            rx="2.5"
          />
        </g>
        <g transform="translate(150 10)">
          <mask id="p" fill="#fff">
            <use xlinkHref="#n" />
          </mask>
          <use fill="#000" filter="url(#o)" xlinkHref="#n" />
          <use fill="#292F36" xlinkHref="#n" />
          <g mask="url(#p)">
            <g transform="translate(-1 10)">
              <use fill="#000" filter="url(#r)" xlinkHref="#q" />
              <path fill="#41464D" d="M0 289h176v29H0z" />
              <path
                fill="#FD6767"
                d="M28 234a11 11 0 1 1 0-22 11 11 0 0 1 0 22zm-3-14.2v6.4a1 1 0 0 0 1.53.84l5.11-3.2a1 1 0 0 0 0-1.69l-5.11-3.2a1 1 0 0 0-1.53.85z"
              />
              <path
                fill="#7F8287"
                fillRule="nonzero"
                d="M33.5 293c-3.02 0-5.5 2.7-5.5 6v2.28c0 .18.05.36.11.54l.33.72c.16.42.55.66.99.66h.22v.6c0 .36.22.6.55.6v.36c0 .12.11.24.22.24h.88c.33 0 .55-.24.55-.6v-3.6c0-.36-.22-.6-.55-.6h-.88c-.11 0-.22.12-.22.24v.36c-.33 0-.55.24-.55.6v.6h-.22l-.33-.72V299c0-2.64 1.98-4.8 4.4-4.8 2.42 0 4.4 2.16 4.4 4.8v2.28l-.33.72h-.22v-.6c0-.36-.22-.6-.55-.6v-.36c0-.12-.11-.24-.22-.24h-.88c-.33 0-.55.24-.55.6v3.6c0 .36.22.6.55.6h.88c.11 0 .22-.12.22-.24v-.36c.33 0 .55-.24.55-.6v-.6h.22c.44 0 .77-.24.99-.66l.33-.72c.05-.18.11-.36.11-.54V299c0-3.3-2.48-6-5.5-6z"
              />
              <path
                fill="#7F8287"
                d="M148.92 301.58c.66.3 1.08.92 1.08 1.61v.61c0 .95-3.27 1.2-5 1.2s-5-.25-5-1.2v-.65c0-.66.4-1.27 1.02-1.58l1.94-.97c.19-.1.3-.28.3-.47v-.66a4.08 4.08 0 0 1-.76-1.45.77.77 0 0 1-.33-.62v-.8c0-.2.08-.38.22-.52V295a1.7 1.7 0 0 1 .46-1.3c.44-.47 1.17-.71 2.15-.71s1.7.24 2.15.7c.52.55.47 1.2.46 1.31v1.07c.14.14.22.33.22.52v.8c0 .32-.2.6-.51.72a4.45 4.45 0 0 1-.8 1.35v.68c0 .2.12.38.32.47l2.08.96z"
              />
              <g transform="translate(9 43)">
                <rect width="160" height="34" fill="#FFF" rx="2" />
                <path
                  fill="#FD6767"
                  d="M19 28a11 11 0 1 1 0-22 11 11 0 0 1 0 22zm-3-14.2v6.4a1 1 0 0 0 1.53.84l5.11-3.2a1 1 0 0 0 0-1.69l-5.11-3.2a1 1 0 0 0-1.53.85z"
                />
                <g fill="#CCCDCF">
                  <path d="M143 20h8v-1h-8zM143 18h8v-1h-8zM143 16h8v-1h-8z" />
                </g>
                <path
                  fill="#989898"
                  fillRule="nonzero"
                  d="M39.65 14.46h.83V19h-.83v-4.54zm2.7 1.73c.23-.46.6-.68 1.09-.68.42 0 .73.13.94.41.22.28.32.64.32 1.1V19h-.82v-1.99c0-.25-.06-.44-.19-.57a.67.67 0 0 0-.5-.2.7.7 0 0 0-.57.3c-.16.2-.24.5-.25.89V19h-.82v-3.4h.72l.09.59zm5.24 2.73c-.3.12-.55.18-.73.18-.17 0-.33-.02-.46-.07-.14-.04-.25-.1-.36-.18a1 1 0 0 1-.32-.8v-1.9h-.47v-.55h.47v-.9h.83v.9h.92v.55h-.92v1.88c0 .28.13.42.4.42.13 0 .3-.04.52-.11l.12.58zm1.44-2.65c.2-.49.51-.73.92-.73.08 0 .18.01.3.04v.83a1.83 1.83 0 0 0-.4-.04c-.54 0-.82.38-.82 1.14V19h-.83v-3.4h.83v.67zm3.2-.76c.22 0 .43.03.63.1.2.08.38.19.52.34.32.32.49.78.49 1.36 0 .57-.17 1.01-.49 1.34-.29.3-.67.45-1.16.45-.48 0-.88-.15-1.18-.45a1.82 1.82 0 0 1-.48-1.34c0-.59.16-1.04.48-1.36.3-.3.7-.44 1.18-.44zm.81 1.79c0-.36-.07-.63-.21-.8a.7.7 0 0 0-.58-.28.78.78 0 0 0-.62.27c-.16.18-.24.45-.24.8 0 .37.08.64.22.82a.7.7 0 0 0 .58.27c.25 0 .45-.1.61-.27.16-.18.24-.45.24-.81z"
                />
              </g>
              <g transform="translate(9 165)">
                <rect width="160" height="34" fill="#FFF" rx="2" />
                <path
                  fill="#FEABE6"
                  d="M19 28a11 11 0 1 1 0-22 11 11 0 0 1 0 22zm-3-14.2v6.4a1 1 0 0 0 1.53.84l5.11-3.2a1 1 0 0 0 0-1.69l-5.11-3.2a1 1 0 0 0-1.53.85z"
                />
                <path
                  fill="#989898"
                  fillRule="nonzero"
                  d="M39.04 14.46h3.64v.71h-1.4V19h-.83v-3.83h-1.4v-.71zm4.33 1.81c.2-.49.52-.73.93-.73.08 0 .18.01.3.04l-.02.83a1.83 1.83 0 0 0-.38-.04c-.55 0-.83.38-.83 1.14V19h-.82v-3.4h.82v.67zm2.98.74c.27 0 .58.05.93.13v-.33c0-.24-.04-.42-.14-.53-.1-.11-.25-.17-.47-.17a.83.83 0 0 0-.5.13.43.43 0 0 0-.17.37h-.9c0-.4.13-.67.4-.84.27-.18.66-.26 1.15-.26.7 0 1.15.24 1.35.73.07.17.1.37.1.6V19h-.71l-.06-.45a1.1 1.1 0 0 1-1.01.55c-.44 0-.78-.1-1.02-.32-.23-.2-.34-.47-.34-.78 0-.32.12-.56.37-.73.25-.17.59-.26 1.02-.26zm.93.66a2.95 2.95 0 0 0-.77-.11c-.44 0-.67.15-.67.45 0 .12.05.23.16.32.1.1.26.14.49.14.23 0 .41-.08.56-.23a.84.84 0 0 0 .23-.57zm2.61-1.48c.23-.46.59-.68 1.08-.68.42 0 .74.13.95.41.21.28.32.64.32 1.1V19h-.83v-1.99c0-.25-.06-.44-.18-.57a.67.67 0 0 0-.51-.2.7.7 0 0 0-.57.3c-.15.2-.23.5-.24.89V19h-.83v-3.4h.72l.1.59zm3.78 1.77c0 .33.24.49.7.49.18 0 .33-.04.44-.12.12-.08.18-.17.18-.27s-.04-.18-.1-.24c-.08-.05-.19-.1-.34-.15l-.74-.27c-.55-.19-.83-.5-.83-.93a.8.8 0 0 1 .4-.7c.25-.18.6-.26 1.04-.26.43 0 .77.1 1 .28.24.2.36.44.37.73h-.78c0-.12-.06-.2-.16-.27a.76.76 0 0 0-.42-.1.71.71 0 0 0-.42.11c-.1.07-.15.15-.15.25 0 .16.14.28.41.36l.8.3c.27.1.48.2.62.34s.21.32.21.54c0 .28-.13.52-.4.73-.27.21-.64.32-1.09.32-.45 0-.81-.1-1.09-.3a.99.99 0 0 1-.42-.84h.77zm3.06-2.37h.83V19h-.83v-3.4zm-.1-1.1c0-.14.05-.26.14-.34.09-.1.21-.13.38-.13.16 0 .28.04.37.13.1.08.14.2.14.35 0 .15-.05.27-.14.35a.52.52 0 0 1-.37.13c-.17 0-.3-.04-.38-.13a.47.47 0 0 1-.13-.35zm4.01 4.43c-.3.12-.55.18-.72.18-.18 0-.34-.02-.47-.07-.13-.04-.25-.1-.35-.18a1 1 0 0 1-.33-.8v-1.9h-.47v-.55h.48v-.9h.82v.9h.92v.55h-.92v1.88c0 .28.13.42.4.42.14 0 .31-.04.52-.11l.12.58zm.69-3.33h.82V19h-.82v-3.4zm-.1-1.1c0-.14.04-.26.13-.34.1-.1.22-.13.38-.13s.28.04.38.13c.09.08.13.2.13.35 0 .15-.04.27-.13.35a.52.52 0 0 1-.38.13c-.16 0-.29-.04-.38-.13a.47.47 0 0 1-.13-.35zm3.43 1.02c.23 0 .44.03.64.1.2.08.37.19.52.34.32.32.48.78.48 1.36 0 .57-.16 1.01-.48 1.34-.29.3-.68.45-1.16.45-.49 0-.88-.15-1.18-.45a1.82 1.82 0 0 1-.48-1.34c0-.59.16-1.04.48-1.36.3-.3.69-.44 1.18-.44zm.82 1.79c0-.36-.07-.63-.21-.8a.7.7 0 0 0-.59-.28.78.78 0 0 0-.61.27c-.16.18-.24.45-.24.8 0 .37.07.64.21.82a.7.7 0 0 0 .59.27c.25 0 .45-.1.6-.27.17-.18.25-.45.25-.81zm2.38-1.11c.23-.46.58-.68 1.08-.68.42 0 .74.13.95.41.21.28.32.64.32 1.1V19h-.83v-1.99c0-.25-.06-.44-.18-.57a.67.67 0 0 0-.51-.2.7.7 0 0 0-.57.3c-.15.2-.24.5-.25.89V19h-.82v-3.4h.72l.1.59z"
                />
                <g fill="#CCCDCF">
                  <path d="M143 20h8v-1h-8zM143 18h8v-1h-8zM143 16h8v-1h-8z" />
                </g>
              </g>
              <g fill="#CCCDCF">
                <path d="M152 185h8v-1h-8zM152 183h8v-1h-8zM152 181h8v-1h-8z" />
              </g>
              <g transform="translate(9 84)">
                <rect width="160" height="34" fill="#FFF" rx="2" />
                <g fill="#CCCDCF">
                  <path d="M143 20h8v-1h-8zM143 18h8v-1h-8zM143 16h8v-1h-8z" />
                </g>
                <path
                  fill="#1CEE4E"
                  d="M29.99 17.07c0 5.97-4.92 10.82-11 10.82C12.92 27.9 8 23.04 8 17.07c0-5.98 4.92-10.83 11-10.83 6.07 0 10.99 4.85 10.99 10.83"
                />
                <path
                  fill="#FFF"
                  d="M23.06 21.26c-.55.6-1.26 1-2.09 1.2-.36.09-.52.26-.5.6l-.01 1c0 .29-.17.45-.5.46h-1.19c-.35 0-.51-.18-.52-.5v-.72c-.01-.53-.03-.56-.6-.64a8.17 8.17 0 0 1-2.13-.54c-.53-.23-.58-.35-.43-.85l.35-1.1c.15-.43.28-.48.72-.28.74.35 1.53.54 2.35.64a3.2 3.2 0 0 0 1.55-.19c.92-.36 1.07-1.32.29-1.9-.27-.19-.57-.33-.88-.45-.8-.32-1.65-.57-2.41-.98-1.24-.66-2.03-1.57-1.93-2.93.1-1.52 1.06-2.48 2.62-2.99.65-.2.65-.2.65-.8v-.61c.02-.46.1-.54.6-.55h.48c1.08 0 1.08 0 1.08.96 0 .69 0 .69.76.8.58.08 1.13.23 1.67.44.3.12.41.3.32.59-.14.41-.26.83-.41 1.25-.14.39-.28.44-.7.26a5.84 5.84 0 0 0-2.65-.47 2.2 2.2 0 0 0-.7.13c-.8.32-.94 1.1-.25 1.6.34.25.74.43 1.15.58.7.26 1.42.52 2.1.85 2.14 1.07 2.72 3.49 1.2 5.14"
                />
                <path
                  fill="#989898"
                  fillRule="nonzero"
                  d="M42.04 15.71c-.08-.4-.36-.6-.84-.6a.94.94 0 0 0-.56.15c-.13.1-.2.21-.2.35 0 .13.05.24.13.31.09.08.22.15.4.22l1 .38c.33.13.59.3.77.5.18.2.27.44.27.74 0 .41-.15.74-.46.98-.3.24-.75.36-1.32.36-.5 0-.9-.13-1.22-.37a1.44 1.44 0 0 1-.55-1.15h.81c0 .37.2.6.58.7.12.04.28.05.47.05.19 0 .37-.04.53-.14.16-.1.24-.22.24-.38s-.04-.29-.13-.37a1.26 1.26 0 0 0-.43-.25l-.9-.35c-.36-.14-.62-.3-.81-.48a1 1 0 0 1-.28-.75c0-.38.15-.68.44-.9.3-.23.7-.34 1.21-.34.52 0 .91.11 1.19.35.28.24.43.57.48.99h-.82zm3.98 2.85a.88.88 0 0 1-.87.54c-.44 0-.8-.16-1.1-.48a1.83 1.83 0 0 1-.49-1.32c0-.54.16-.98.47-1.32.3-.31.65-.47 1.08-.47a1.12 1.12 0 0 1 1.02.62l.18-.53h.54v3.92c0 .2.03.34.08.4.04.07.1.12.16.15l.22.09-.23.6c-.39-.1-.66-.25-.82-.45-.16-.2-.24-.49-.24-.85v-.9zm0-1.5c0-.26-.08-.46-.23-.6a.8.8 0 0 0-.57-.21c-.23 0-.42.1-.58.28-.16.19-.25.44-.25.77s.1.6.28.79c.17.17.37.26.6.26.2 0 .36-.06.5-.18.16-.13.24-.3.25-.5v-.62zm4.16 1.32c-.21.46-.56.68-1.03.68-.6 0-1-.23-1.2-.7a1.5 1.5 0 0 1-.1-.6V15.6h.83v2.09c0 .22.05.39.16.5.1.1.24.16.4.16.15 0 .28-.02.39-.06.1-.05.2-.12.28-.2.17-.2.26-.47.27-.8v-1.69h.83V19h-.83v-.62zm3.02-1.37c.27 0 .58.05.93.13v-.33c0-.24-.04-.42-.14-.53-.1-.11-.25-.17-.47-.17a.83.83 0 0 0-.5.13.43.43 0 0 0-.17.37h-.9c0-.4.13-.67.4-.84.28-.18.66-.26 1.15-.26.7 0 1.15.24 1.35.73.08.17.11.37.11.6V19h-.72l-.06-.45a1.1 1.1 0 0 1-1.01.55c-.44 0-.78-.1-1.02-.32-.23-.2-.34-.47-.34-.78 0-.32.12-.56.37-.73.25-.17.59-.26 1.02-.26zm.93.66a2.95 2.95 0 0 0-.77-.11c-.44 0-.67.15-.67.45 0 .12.05.23.16.32.1.1.26.14.49.14.23 0 .41-.08.56-.23a.84.84 0 0 0 .23-.57zm2.63-1.4c.2-.49.51-.73.92-.73.08 0 .18.01.3.04l-.01.83a1.83 1.83 0 0 0-.39-.04c-.55 0-.82.38-.82 1.14V19h-.83v-3.4h.83v.67zm4.22-.27a1.9 1.9 0 0 1 .35 1.06c0 .16 0 .31-.03.44h-2.2c.02.28.08.5.2.67.14.18.33.26.58.26.34 0 .55-.15.61-.45h.84c-.06.35-.22.61-.47.81-.27.2-.6.3-.98.3-.44 0-.82-.16-1.12-.48a1.86 1.86 0 0 1-.47-1.31c0-.55.15-.99.47-1.32.3-.31.67-.47 1.12-.47.47 0 .84.16 1.1.5zm-1.09.16a.68.68 0 0 0-.55.23c-.13.15-.2.35-.23.59h1.45c0-.37-.11-.62-.35-.75a.68.68 0 0 0-.32-.07zm2.66 1.8c0 .33.24.49.7.49.18 0 .33-.04.44-.12.12-.08.17-.17.17-.27s-.03-.18-.1-.24c-.07-.05-.18-.1-.33-.15l-.74-.27c-.55-.19-.83-.5-.83-.93a.8.8 0 0 1 .4-.7c.25-.18.6-.26 1.03-.26.44 0 .78.1 1.01.28.24.2.36.44.37.73h-.78c0-.12-.06-.2-.16-.27a.76.76 0 0 0-.42-.1.71.71 0 0 0-.42.11c-.1.07-.15.15-.15.25 0 .16.13.28.41.36l.8.3c.27.1.48.2.62.34s.21.32.21.54c0 .28-.13.52-.4.73-.27.21-.64.32-1.09.32-.45 0-.82-.1-1.1-.3a.99.99 0 0 1-.41-.84h.77zm3.75-1.9c.21-.37.54-.55.98-.55.42 0 .78.16 1.08.47.31.34.47.78.47 1.32 0 .55-.16.99-.48 1.32-.3.32-.66.48-1.07.48-.42 0-.72-.13-.91-.37v1.93h-.83V15.6h.68l.08.46zm.83 2.29a.82.82 0 0 0 .59-.26c.19-.2.28-.46.28-.79s-.08-.58-.24-.77a.75.75 0 0 0-.6-.28.81.81 0 0 0-.56.2.77.77 0 0 0-.23.57v.6c0 .23.07.4.23.54.14.13.32.19.53.19zM70.7 17c.27 0 .58.05.94.13v-.33c0-.24-.05-.42-.15-.53-.1-.11-.25-.17-.47-.17a.83.83 0 0 0-.5.13.43.43 0 0 0-.17.37h-.9c0-.4.13-.67.4-.84.28-.18.66-.26 1.15-.26.7 0 1.15.24 1.36.73.07.17.1.37.1.6V19h-.72l-.06-.45a1.1 1.1 0 0 1-1.01.55c-.44 0-.78-.1-1.02-.32-.23-.2-.34-.47-.34-.78 0-.32.13-.56.37-.73.25-.17.59-.26 1.02-.26zm.94.66a2.95 2.95 0 0 0-.77-.11c-.45 0-.68.15-.68.45 0 .12.06.23.16.32.1.1.27.14.5.14.22 0 .4-.08.55-.23a.84.84 0 0 0 .24-.57zm3.09-2.16a1.34 1.34 0 0 1 1 .4c.24.21.38.5.42.84l-.83.02a.77.77 0 0 0-.21-.37.48.48 0 0 0-.35-.15.86.86 0 0 0-.33.06c-.1.04-.18.1-.25.18-.16.2-.24.47-.24.82 0 .34.08.6.23.78.15.17.33.26.54.26.21 0 .37-.05.46-.15.1-.1.15-.24.15-.41h.83c0 .37-.12.68-.37.93s-.6.38-1.06.38c-.45 0-.82-.17-1.13-.5a1.86 1.86 0 0 1-.48-1.3c0-.55.16-1 .48-1.32.3-.32.69-.47 1.14-.47zm4.55.5c.12.14.2.32.27.51.05.2.08.38.08.54 0 .16 0 .31-.03.44h-2.2c.02.28.08.5.21.67.13.18.32.26.57.26.34 0 .55-.15.61-.45h.84c-.06.35-.22.61-.47.81-.27.2-.6.3-.98.3-.44 0-.82-.16-1.12-.48a1.86 1.86 0 0 1-.47-1.31c0-.55.15-.99.47-1.32.3-.31.67-.47 1.12-.47.48 0 .84.16 1.1.5zm-1.09.15a.68.68 0 0 0-.55.23c-.13.15-.2.35-.23.59h1.45c0-.37-.11-.62-.35-.75a.68.68 0 0 0-.32-.07z"
                />
              </g>
              <g transform="translate(9 124)">
                <rect width="160" height="34" fill="#FFF" rx="2" />
                <path
                  fill="#FD6767"
                  d="M19 28a11 11 0 1 1 0-22 11 11 0 0 1 0 22zm-3-14.2v6.4a1 1 0 0 0 1.53.84l5.11-3.2a1 1 0 0 0 0-1.69l-5.11-3.2a1 1 0 0 0-1.53.85z"
                />
                <path
                  fill="#989898"
                  fillRule="nonzero"
                  d="M40.58 14.46h3.64v.71h-1.4V19h-.83v-3.83h-1.41v-.71zm4.93 1.7c.23-.44.57-.65 1.02-.65.45 0 .78.13.99.41.21.28.32.64.32 1.1V19H47v-1.99c0-.25-.06-.44-.18-.57a.67.67 0 0 0-.51-.2.7.7 0 0 0-.57.3c-.15.2-.24.5-.24.89V19h-.83v-4.8h.83v1.95zm3.37-.57h.82V19h-.82v-3.4zm-.1-1.1c0-.14.04-.26.13-.34.1-.1.22-.13.38-.13s.28.04.37.13c.1.08.14.2.14.35 0 .15-.04.27-.14.35a.52.52 0 0 1-.37.13c-.16 0-.29-.04-.38-.13a.47.47 0 0 1-.13-.35zm2.55 3.47c.01.33.25.49.7.49.19 0 .33-.04.45-.12.11-.08.17-.17.17-.27s-.04-.18-.1-.24c-.08-.05-.19-.1-.34-.15l-.74-.27c-.55-.19-.82-.5-.82-.93a.8.8 0 0 1 .38-.7c.26-.18.61-.26 1.05-.26.43 0 .77.1 1 .28.24.2.36.44.37.73h-.77c-.01-.12-.07-.2-.17-.27a.76.76 0 0 0-.42-.1.71.71 0 0 0-.42.11c-.1.07-.15.15-.15.25 0 .16.14.28.41.36l.8.3c.27.1.48.2.62.34s.21.32.21.54c0 .28-.13.52-.4.73-.27.21-.63.32-1.09.32-.45 0-.81-.1-1.09-.3a.99.99 0 0 1-.42-.84h.77zm4.83-2.36l.69 2.43.65-2.24h.75l.65 2.24.7-2.43h.82L59.3 19h-.81l-.63-2.04-.62 2.04h-.82l-1.12-3.4h.86zm7.15.4a1.9 1.9 0 0 1 .35 1.06c0 .16-.01.31-.03.44h-2.2c.01.28.08.5.2.67.13.18.32.26.58.26.34 0 .54-.15.6-.45h.84c-.05.35-.21.61-.47.81-.26.2-.59.3-.97.3-.45 0-.82-.16-1.13-.48a1.86 1.86 0 0 1-.47-1.31c0-.55.16-.99.47-1.32.3-.31.68-.47 1.13-.47.47 0 .84.16 1.1.5zm-1.1.16a.68.68 0 0 0-.54.23c-.13.15-.2.35-.23.59h1.45c0-.37-.12-.62-.35-.75a.68.68 0 0 0-.32-.07zM66.8 16a1.9 1.9 0 0 1 .35 1.06c0 .16-.01.31-.03.44h-2.2c0 .28.08.5.2.67.13.18.32.26.58.26.34 0 .54-.15.6-.45h.84c-.06.35-.21.61-.47.81-.27.2-.6.3-.97.3-.45 0-.83-.16-1.13-.48a1.86 1.86 0 0 1-.47-1.31c0-.55.16-.99.47-1.32.3-.31.67-.47 1.13-.47.47 0 .83.16 1.1.5zm-1.1.16a.68.68 0 0 0-.54.23c-.13.15-.21.35-.23.59h1.45c0-.37-.12-.62-.35-.75a.68.68 0 0 0-.33-.07zm3.4 1.18l-.38.32V19h-.82v-4.8h.83v2.6l1.34-1.2h1.12l-1.5 1.26L71.25 19h-1l-1.17-1.66zm2.32-2.4c0-.15.05-.26.16-.36.1-.1.25-.14.44-.14.18 0 .33.07.45.22.12.14.18.33.18.54 0 .22-.08.43-.23.64-.15.21-.35.38-.6.5l-.58-.3c.36-.19.58-.4.65-.62a.68.68 0 0 1-.34-.16.41.41 0 0 1-.13-.33zm2.4 3.02c0 .33.24.49.7.49.18 0 .33-.04.44-.12.12-.08.17-.17.17-.27s-.03-.18-.1-.24c-.07-.05-.18-.1-.33-.15l-.74-.27c-.55-.19-.83-.5-.83-.93a.8.8 0 0 1 .39-.7c.26-.18.6-.26 1.04-.26.44 0 .77.1 1.01.28.24.2.36.44.37.73h-.78c0-.12-.06-.2-.16-.27a.76.76 0 0 0-.42-.1.71.71 0 0 0-.42.11c-.1.07-.15.15-.15.25 0 .16.13.28.4.36l.81.3c.27.1.47.2.62.34.14.14.2.32.2.54 0 .28-.12.52-.39.73-.28.21-.64.32-1.1.32-.44 0-.8-.1-1.08-.3a.99.99 0 0 1-.42-.84h.77zm4.99 0c0 .33.24.49.7.49.18 0 .33-.04.44-.12.12-.08.18-.17.18-.27s-.04-.18-.1-.24c-.08-.05-.19-.1-.34-.15l-.74-.27c-.55-.19-.83-.5-.83-.93a.8.8 0 0 1 .4-.7c.25-.18.6-.26 1.04-.26.43 0 .77.1 1 .28.24.2.36.44.37.73h-.78c0-.12-.06-.2-.16-.27a.76.76 0 0 0-.42-.1.71.71 0 0 0-.42.11c-.1.07-.15.15-.15.25 0 .16.14.28.41.36l.8.3c.27.1.48.2.62.34s.21.32.21.54c0 .28-.13.52-.4.73-.27.21-.64.32-1.09.32-.45 0-.81-.1-1.09-.3a.99.99 0 0 1-.42-.84h.77zm4.91.96c-.3.12-.55.18-.73.18-.17 0-.33-.02-.46-.07-.14-.04-.25-.1-.36-.18a1 1 0 0 1-.32-.8v-1.9h-.47v-.55h.47v-.9h.83v.9h.92v.55h-.92v1.88c0 .28.13.42.4.42.13 0 .3-.04.52-.11l.12.58zm1.95-3.41c.23 0 .45.03.65.1.2.08.37.19.51.34.33.32.49.78.49 1.36 0 .57-.16 1.01-.49 1.34-.29.3-.67.45-1.16.45-.48 0-.88-.15-1.17-.45a1.82 1.82 0 0 1-.49-1.34c0-.59.16-1.04.49-1.36.29-.3.68-.44 1.17-.44zm.82 1.79c0-.36-.07-.63-.2-.8a.7.7 0 0 0-.6-.28.78.78 0 0 0-.6.27c-.16.18-.24.45-.24.8 0 .37.07.64.2.82a.7.7 0 0 0 .6.27c.24 0 .44-.1.6-.27.16-.18.24-.45.24-.81zm2.4-1.03c.2-.49.51-.73.92-.73.08 0 .18.01.3.04v.83a1.83 1.83 0 0 0-.4-.04c-.55 0-.82.38-.82 1.14V19h-.83v-3.4h.83v.67zm2.27-.67l.82 2.45.72-2.45h.84l-1.3 4.02c-.14.4-.3.7-.5.87-.2.18-.44.27-.74.27s-.6-.08-.9-.23v-.73c.23.16.48.24.73.24a.5.5 0 0 0 .4-.2c.1-.13.19-.3.25-.51l.1-.33-1.36-3.4h.94zm4.88 2.36c0 .33.24.49.7.49.18 0 .33-.04.44-.12.12-.08.17-.17.17-.27s-.03-.18-.1-.24c-.07-.05-.18-.1-.33-.15l-.74-.27c-.55-.19-.83-.5-.83-.93a.8.8 0 0 1 .39-.7c.26-.18.6-.26 1.04-.26.44 0 .77.1 1.01.28.24.2.36.44.37.73h-.78c0-.12-.06-.2-.16-.27a.76.76 0 0 0-.42-.1.71.71 0 0 0-.42.11c-.1.07-.15.15-.15.25 0 .16.13.28.4.36l.81.3c.27.1.47.2.62.34.14.14.21.32.21.54 0 .28-.13.52-.4.73-.27.21-.64.32-1.1.32-.44 0-.8-.1-1.08-.3a.99.99 0 0 1-.42-.84h.77zm5.36-1.96c.12.15.2.33.27.52.05.2.08.38.08.54 0 .16 0 .31-.02.44h-2.2c0 .28.07.5.2.67.13.18.32.26.57.26.35 0 .55-.15.61-.45h.84c-.06.35-.22.61-.47.81-.27.2-.6.3-.98.3-.44 0-.82-.16-1.12-.48a1.86 1.86 0 0 1-.47-1.31c0-.55.15-.99.47-1.32.3-.31.67-.47 1.12-.47.48 0 .84.16 1.1.5zm-1.09.16a.68.68 0 0 0-.54.23c-.14.15-.21.35-.24.59h1.45c0-.37-.11-.62-.35-.75a.68.68 0 0 0-.32-.07zm2.5 1.45a1.1 1.1 0 0 1-.42-.88c0-.37.14-.67.43-.9a1.84 1.84 0 0 1 1.87-.13.92.92 0 0 1 .34-.63c.2-.17.43-.25.7-.25l-.05.8c-.4 0-.6.12-.62.4.17.2.26.42.26.65 0 .22-.04.41-.12.56-.08.15-.18.28-.32.38-.28.23-.62.34-1.02.34-.23 0-.44-.03-.63-.1-.18.05-.28.16-.28.33 0 .21.18.32.54.32h1.14c.77 0 1.16.27 1.16.8 0 .19-.05.37-.14.54-.09.18-.22.33-.4.47-.37.3-.86.45-1.43.45-.56 0-1.02-.12-1.37-.35-.33-.22-.49-.48-.49-.8 0-.21.07-.38.2-.5.12-.13.3-.2.5-.24-.27-.16-.41-.37-.41-.62 0-.16.05-.3.15-.4.1-.12.24-.2.4-.24zm.62 1.47c-.44.02-.66.18-.66.5 0 .15.1.28.28.38.18.1.4.14.65.14.26 0 .45-.02.6-.06.14-.05.26-.1.36-.17.2-.14.31-.31.31-.5a.27.27 0 0 0-.09-.21c-.05-.06-.14-.08-.25-.08h-1.2zm1.07-2.35c0-.2-.05-.35-.16-.47-.1-.12-.26-.18-.47-.18-.22 0-.38.06-.5.18a.65.65 0 0 0-.16.46c0 .2.05.35.16.47.12.12.28.18.5.18.21 0 .37-.06.47-.18.11-.12.16-.28.16-.46zm4.87-.49c.22-.49.6-.73 1.16-.73.4 0 .72.13.94.41.22.26.32.63.32 1.1V19h-.83v-1.99c0-.25-.06-.44-.18-.57a.67.67 0 0 0-.51-.2c-.22 0-.4.1-.54.3-.14.19-.22.48-.23.86V19h-.82v-1.99c0-.25-.06-.44-.18-.57a.67.67 0 0 0-.51-.2.7.7 0 0 0-.57.3c-.15.2-.24.5-.25.89V19h-.82v-3.4h.72l.09.59c.22-.46.58-.68 1.08-.68.28 0 .52.06.7.2.2.12.34.3.43.53zm5.76-.24a1.9 1.9 0 0 1 .35 1.06c0 .16 0 .31-.03.44h-2.2c.01.28.08.5.2.67.13.18.32.26.58.26.34 0 .55-.15.61-.45h.83c-.05.35-.2.61-.47.81-.26.2-.59.3-.97.3-.45 0-.82-.16-1.13-.48a1.86 1.86 0 0 1-.46-1.31c0-.55.15-.99.46-1.32.3-.31.68-.47 1.13-.47.47 0 .84.16 1.1.5zm-1.1.16a.68.68 0 0 0-.54.23c-.13.15-.2.35-.23.59h1.45c0-.37-.12-.62-.35-.75a.68.68 0 0 0-.32-.07zm3.02.03c.22-.46.58-.68 1.07-.68.42 0 .74.13.95.41.21.28.32.64.32 1.1V19h-.82v-1.99c0-.25-.07-.44-.19-.57a.67.67 0 0 0-.5-.2.7.7 0 0 0-.57.3c-.16.2-.24.5-.25.89V19h-.83v-3.4h.72l.1.59zm5.23 2.73c-.3.12-.55.18-.73.18-.18 0-.33-.02-.46-.07-.14-.04-.25-.1-.36-.18a1 1 0 0 1-.32-.8v-1.9h-.48v-.55h.48v-.9h.83v.9h.92v.55h-.92v1.88c0 .28.13.42.4.42.13 0 .3-.04.52-.11l.12.58z"
                />
                <g fill="#CCCDCF">
                  <path d="M143 20h8v-1h-8zM143 18h8v-1h-8zM143 16h8v-1h-8z" />
                </g>
              </g>
              <g fill="#CCCDCF">
                <path d="M152 144h8v-1h-8zM152 142h8v-1h-8zM152 140h8v-1h-8z" />
              </g>
              <rect
                width="83"
                height="8"
                x="88"
                y="31"
                fill="#292F36"
                rx="2.5"
              />
              <rect width="164" height="21" x="7" fill="#8840F9" rx="2.5" />
              <path fill="#FFF" d="M19.98 8l.7.7-5.65 5.66-.71-.7z" />
              <path fill="#FFF" d="M15.02 8l-.7.7 5.65 5.66.71-.7z" />
              <text
                fontFamily="Karla-Bold, Karla"
                fontSize="7.01"
                fontWeight="bold"
                letterSpacing="-.1"
              >
                <tspan x="28.46" y="13" fill="#FFF">
                  Rearrange segments
                </tspan>
              </text>
              <text
                fontFamily="Karla-Bold, Karla"
                fontSize="7.01"
                fontWeight="bold"
                letterSpacing="-.1"
              >
                <tspan x="147.24" y="13" fill="#FFF">
                  Save
                </tspan>
              </text>
              <g transform="translate(9 206)">
                <rect width="160" height="34" fill="#FFF" rx="2" />
                <path
                  fill="#989898"
                  fillRule="nonzero"
                  d="M41.4 14.37c.3 0 .57.05.83.15.25.1.47.24.65.44.38.41.57 1 .57 1.77s-.19 1.36-.57 1.78c-.37.4-.86.59-1.5.59a1.9 1.9 0 0 1-1.48-.6c-.38-.42-.57-1.01-.57-1.77 0-.78.19-1.37.57-1.78.36-.39.86-.58 1.5-.58zm1.2 2.37c0-.52-.11-.93-.33-1.2a1.05 1.05 0 0 0-.88-.43c-.36 0-.66.14-.88.42-.22.28-.33.69-.33 1.2 0 .53.11.92.33 1.2.22.28.52.42.88.42.37 0 .67-.14.88-.42.22-.28.33-.67.33-1.2zm3.86 1.64c-.22.46-.56.68-1.04.68-.6 0-1-.23-1.19-.7a1.5 1.5 0 0 1-.1-.6V15.6h.82v2.09c0 .22.06.39.17.5.1.1.23.16.4.16.15 0 .28-.02.39-.06.1-.05.2-.12.28-.2.17-.2.26-.47.27-.8v-1.69h.83V19h-.83v-.62zm3.81.54c-.3.12-.55.18-.73.18-.17 0-.33-.02-.46-.07-.13-.04-.25-.1-.35-.18a1 1 0 0 1-.33-.8v-1.9h-.47v-.55h.47v-.9h.83v.9h.92v.55h-.92v1.88c0 .28.13.42.4.42.13 0 .3-.04.52-.11l.12.58zm1.44-2.65c.2-.49.52-.73.93-.73.08 0 .18.01.3.04l-.02.83a1.83 1.83 0 0 0-.38-.04c-.55 0-.83.38-.83 1.14V19h-.82v-3.4h.82v.67zm3.2-.76c.22 0 .43.03.64.1.2.08.37.19.51.34.33.32.49.78.49 1.36 0 .57-.16 1.01-.49 1.34-.29.3-.67.45-1.16.45-.48 0-.88-.15-1.17-.45a1.82 1.82 0 0 1-.49-1.34c0-.59.16-1.04.49-1.36.29-.3.68-.44 1.17-.44zm.81 1.79c0-.36-.07-.63-.2-.8a.7.7 0 0 0-.6-.28.78.78 0 0 0-.6.27c-.17.18-.24.45-.24.8 0 .37.07.64.2.82a.7.7 0 0 0 .6.27c.24 0 .44-.1.6-.27.16-.18.24-.45.24-.81z"
                />
                <g fill="#CCCDCF">
                  <path d="M143 20h8v-1h-8zM143 18h8v-1h-8zM143 16h8v-1h-8z" />
                </g>
                <path
                  fill="#FD6767"
                  d="M19 28a11 11 0 1 1 0-22 11 11 0 0 1 0 22zm-3-14.2v6.4a1 1 0 0 0 1.53.84l5.11-3.2a1 1 0 0 0 0-1.69l-5.11-3.2a1 1 0 0 0-1.53.85z"
                />
              </g>
            </g>
          </g>
        </g>
        <circle cx="238" cy="310" r="12" fill="#8940FA" />
        <g fill="#FFF">
          <path d="M243.5 309.5v1h-10v-1z" />
          <path d="M239 305h-1v10h1z" />
        </g>
        <rect width="54" height="8" x="167" y="51.3" fill="#292F36" rx="4" />
        <rect width="52" height="4.6" x="158" y="53" fill="#495058" rx="2.3" />
      </g>
    </svg>
  );
};
export { ToolsSvg };
